const initWordCounts = (els) => {
    els.forEach((el) => {
        const target = el.querySelector('.js-word-count');
        const input = el.querySelector('textarea');
        const { limit } = el.dataset;
        const formattedLimit = parseInt(limit, 10);

        input.addEventListener('input', (e) => {
            const { value } = e.target;
            const charCount = value.length;

            if (charCount > limit) {
                e.target.value = value.slice(0, limit);
                input.value = e.target.value;
            } else {
                input.value = value;
            }

            if (target) {
                target.textContent = `(${Math.min(charCount, formattedLimit)}/${formattedLimit})`;
            }
        });
    });
};

export default initWordCounts;
